import { gql } from '@apollo/client';

export const QUERY_BIG_QUERY_SYNC_JOBS = gql`
  query BigQuerySyncJobs($limit: Int, $offset: Int, $status: BigQuerySyncJobStatus) {
    bigQuerySyncJobs(limit: $limit, offset: $offset, status: $status) {
      id
      status
      created_by_uid
      progress_label
      error
      created_at
      updated_at
      completed_at
    }
  }
`;

export const QUERY_BIG_QUERY_SYNC_PREVIEW_STATUS = gql`
  query BigQuerySyncPreviewStatus($jobId: String!) {
    bigQuerySyncPreviewStatus(jobId: $jobId) {
      id
      status
      error
      stats_json
      progress_label
      blocked_reason
      drift_json
      created_at
      updated_at
    }
  }
`;

export const QUERY_BIG_QUERY_SYNC_PREVIEW_DIFF_PAGE = gql`
  query BigQuerySyncPreviewDiffPage(
    $jobId: String!
    $limit: Int
    $cursor: String
    $entity: String
  ) {
    bigQuerySyncPreviewDiffPage(jobId: $jobId, limit: $limit, cursor: $cursor, entity: $entity) {
      lines {
        entity
        op
        natural_key_json
        before_json
        after_json
      }
      next_cursor
    }
  }
`;
